import axios from 'axios'

function dingRequest(data = {}) {
	// let str = encodeURI(JSON.stringify(data).replace(/"/g,'')) 
	// console.log(str,'str')
	// let param = {"text": data,isCheck:true}
	let param = '{"msgtype": "text","text": {"content":"验签失败:' + data + '"}}'
	console.log(param, 'param')
	return new Promise((resolve, reject) => {
		axios({
				// url: 'https://cytx-stage-new-api.chuangyetianxia.com/pay/refund',
				url: '/api/robot/send?access_token=fdd26a96b2318b76b341314c7ef5d3153fdd93ecefc5bc051e710413744f5d37',
				method: 'post',
				data: param,
				headers: {
					"Content-Type": "application/json"
				}
			})
			.then(res => {
				resolve(res)
			})
			.catch(err => {
				reject(err)
			})
	})
}

export {
	dingRequest
}
